// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LandingTitle_wrap__3WVS4","title":"LandingTitle_title__2TV08","subTitle":"LandingTitle_subTitle__1ylEc"};